import styled from 'styled-components'
import {
  CircleButton,
  FontIcon,
  tokens,
  Button
} from '@arvoreeducacao/bonsai-ds'

export const LoaderWrapper = styled.div`
  position: absolute;
  background-color: rgb(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1000;
  margin-top: 50vh;
`

export const Content = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 610px;
  max-height: 240px;
  margin-bottom: 32px;
`

export const Title = styled.h2`
  margin: 8px 0 40px 0;
  text-align: center;
  font-size: ${tokens.sizes.h[5].tablet};
  color: ${tokens.colors.black6};
  max-width: 460px;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    font-size: ${tokens.sizes.h[3].tablet};
  }
`

export const Text = styled.p`
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.sizes.text}px;
  line-height: ${tokens.sizes.text}px;
  margin: 0;
  text-align: center;
  color: ${tokens.colors.black5};
`

export const HelperText = styled.p`
  font-size: ${tokens.sizes.bodySmall}px;
  line-height: ${tokens.sizes.bodySmall}px;
  margin: 8px 0 0 0;
  text-align: left;
  color: ${tokens.colors.black4};
  width: 100%;
`

export const WarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 12px;
  padding: 12px 16px;
  background-color: ${tokens.colors.yellow1};
  border: 1px solid ${tokens.colors.yellow3};
  border-radius: ${tokens.radius.large};
  width: 100%;
`

export const WarningIcon = styled(FontIcon)`
  color: ${tokens.colors.yellow3};
  flex-shrink: 0;
  margin-top: 2px;
`

export const WarningText = styled.p`
  font-size: ${tokens.sizes.text}px;
  line-height: 20px;
  margin: 0;
  color: ${tokens.colors.black6};
  font-weight: ${tokens.fontWeights.medium};

  a {
    color: ${tokens.colors.primary};
    text-decoration: underline;

    &:hover {
      color: ${tokens.colors.primaryDark};
    }
  }
`

export const ButtonWrapper = styled.div`
  height: 120px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 56px 0;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 390px;
    flex-direction: row;
    margin-bottom: 0;
    height: auto;
  }
`

export const CustomButton = styled(Button)`
  width: 90%;
  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 190px;
  }
`

export const SchoolInfoWrapper = styled.div`
  width: 90%;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 390px;
  }
`

export const SchoolInfo = styled.div`
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.sizes.bodySmall}px;
  line-height: ${tokens.sizes.bodySmall}px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  padding: 24px 32px;
  width: 100%;

  border: 1px solid ${tokens.colors.paleGreyFour};
  box-sizing: border-box;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.06));
  border-radius: ${tokens.radius.large};

  margin: 10px 0px;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    font-size: ${tokens.sizes.text}px;
    line-height: ${tokens.sizes.text}px;
  }
`

export const CustomIcon = styled(FontIcon)`
  color: ${tokens.colors.black4};
  place-self: initial;
  margin-right: 24px;
`

export const BackArrowButton = styled(CircleButton)`
  top: 0;
  margin-right: auto;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    position: absolute;
    left: 70px;
    top: 70px;
    margin-right: 0;
  }
`

export const SelectWrapper = styled.div`
  width: 90%;
  margin-top: 20px;
  position: relative;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 390px;
  }
`

export const InlineSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  width: 100%;
`
